// extracted by mini-css-extract-plugin
export default {"scroll_btn":"ScrollToTopButton_scroll_btn__FhJzj","button":"ScrollToTopButton_button__agP+L","show":"ScrollToTopButton_show__Xs83S","hide":"ScrollToTopButton_hide__fL6OS"};